import Highcharts from "highcharts";
import { PIE_CHART_CONFIG } from "src/config/charts/pieChartConfig";
import { COLOR_LIST } from "src/constants/dashboard";

function buildPieOptions(data: any[]) {
  return {
    ...PIE_CHART_CONFIG,
    series: [
      {
        name: "Percentage",
        type: "pie",
        data: data.map((item, key) => ({
          name: `${(item.name || "")
            .toLowerCase()
            .replace(/(^\w|[-\s]\w)/g, (match: string) =>
              match.toUpperCase(),
            )} <b>(${item.value})</b>`,
          title: `${(item.name || "")
            .toLowerCase()
            .replace(/(^\w|[-\s]\w)/g, (match: string) =>
              match.toUpperCase(),
            )}`,
          value: item.value,
          y: Number(item.percentage.toFixed(2)),
          color: COLOR_LIST[key],
        })),
      },
    ],
  };
}

export const renderPie = (
  data: unknown,
  spec: unknown,
  title: string,
): Highcharts.Options => {
  const pieData = Array.isArray(data) ? data : [];
  const options = buildPieOptions(pieData);
  return {
    ...options,
    // title: {
    //   text: title,
    //   align: "left",
    // },
  };
};
